import { SLICE_TYPE } from '@/utils/constants';
import type {
    SiteWideJackpotData,
    SiteWideJackpotMultiplierBoostItem,
    SiteWideJackpotMultiplierBoostPrimary
} from '@/types/aggregation/site-wide-jackpot';
import type { PrismicSlice } from '@/types/prismic/common';

export type MultiplierFormat = {
    multiplier: number;
    wageredAmount: number;
    oneLiner: string;
    userState: string;
    wagerLabel: string;
    shortWagerLabel: string;
    extraInfo: {
        text: string;
        spans: { start: number; end: number; type: string }[];
    };
};

//TODO: move this to logic
export const mapMultipliers = (multipliers: SiteWideJackpotMultiplierBoostItem[]): MultiplierFormat[] =>
    multipliers.map((value) => ({
        multiplier: value.multiplier,
        wageredAmount: value.wagered_amount,
        oneLiner: value.one_liner_title?.[0]?.text ?? '',
        userState: value.user_state?.[0]?.text ?? '',
        wagerLabel: value.wager_label?.[0]?.text ?? '',
        shortWagerLabel: value.short_wager_label?.[0]?.text ?? '',
        extraInfo: {
            text: value.extra_info[0]?.text ?? '',
            spans: [
                {
                    start: value.extra_info[0]?.spans?.[0]?.start ?? 0,
                    end: value.extra_info[0]?.spans?.[0]?.end ?? 0,
                    type: value.extra_info[0]?.spans?.[0]?.type ?? ''
                }
            ]
        }
    }));

export const mapSWJInfo = (prismicData?: SiteWideJackpotData) => {
    const dybSlice = prismicData?.body?.find(
        (slice) => slice.slice_type === SLICE_TYPE.SITE_WIDE_JACKPOT_MULTIPLIERS
    ) as
        | PrismicSlice<
              'jackpot_multiplier_boost',
              SiteWideJackpotMultiplierBoostItem[],
              SiteWideJackpotMultiplierBoostPrimary
          >
        | undefined;
    return {
        enabled: prismicData?.enabled || false,
        oneLiner: prismicData?.one_liner?.[0]?.text,
        tiers: prismicData?.tiers || [],
        introTitle: prismicData?.title_subtitle?.[0]?.text,
        subHeadline: prismicData?.title_subtitle?.[1]?.text,
        tcShortVersion: prismicData?.tc_short_version?.[0]?.text,
        optedInText: prismicData?.opted_in_text?.[0]?.text,
        optedOutText: prismicData?.opted_out_text?.[0]?.text,
        games: prismicData?.promoted_games || [],
        description: prismicData?.description?.map((desc) => desc.text) || [],
        logo: prismicData?.logo?.url,
        alternateLogo: prismicData?.alternate_logo?.url,
        animatedLogo: prismicData?.animated_logo?.url,
        pageBackground: prismicData?.page_background?.url,
        providerJackpotId: prismicData?.provider_jackpot_id?.[0]?.text,
        providerUid: prismicData?.provider?.uid,
        rulesPageUrl: prismicData?.rules_page_url?.url,
        tierAnimationBackground: prismicData?.tier_animation_background?.url,
        rulesPath: prismicData?.rules_path?.url,
        openRulesExternally: prismicData?.open_rules_externally_android_lobby,
        dybShortRules: dybSlice?.primary?.short_rules?.[0]?.text,
        multipliers: dybSlice?.items || []
    };
};
